import React, { useState } from "react";
import LocalSettings from "nexia_mobile/models/local_settings";
import connect from "nexia_mobile/flux_like/store/connect";

const PhoneContext = React.createContext();
export default PhoneContext;

const findPhone = (phones) => {
  let phone;
  const models = phones.models;
  const mobileId = parseInt(LocalSettings.getMobileId());
  for (let index = 0; index < models.length; index++) {
    let currentPhone = models[index];
    let phoneId = currentPhone.get("phone_id");
    if (phoneId === mobileId) {
      phone = currentPhone;
      break;
    }
  }
  return phone;
};

export const PhoneContextWrapper = (props) => {
  const getPhoneFromSession = (session) => {
    const currentPhones = session.get("phones");
    return findPhone(currentPhones);
  };

  const [phone, setPhoneState] = useState(getPhoneFromSession(props.session));

  const setPhone = () => {
    setPhoneState(getPhoneFromSession(props.session));
  };

  return (
    <PhoneContext.Provider
      value={{
        phone,
        setPhone,
      }}
    >
      {props.children}
    </PhoneContext.Provider>
  );
};

export const ConnectedPhoneContextWrapper = connect(
  {
    session: "session",
  },
  PhoneContextWrapper
);



// WEBPACK FOOTER //
// ../nx-components/src/ContextWrappers/PhoneContext.jsx